module.exports = __webpack_public_path__ + "media/images/cplook/mstile-150x150-00376127d1ddb83bac2890d4dc77949f.png";